import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=5283bcaa&"
import script from "./contactForm.vue?vue&type=script&lang=js&"
export * from "./contactForm.vue?vue&type=script&lang=js&"
import style0 from "./contactForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5283bcaa')) {
      api.createRecord('5283bcaa', component.options)
    } else {
      api.reload('5283bcaa', component.options)
    }
    module.hot.accept("./contactForm.vue?vue&type=template&id=5283bcaa&", function () {
      api.rerender('5283bcaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact/contactForm/contactForm.vue"
export default component.exports